import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from '@hokulea/core/forms.module.css';
// import Icon from '../../../components/icon';
import type { ValidationError } from '../';
export interface ErrorsSignature<VALUE> {
    Element: HTMLDivElement;
    Args: {
        // the following are private arguments curried by the component helper, so users will never have to use those
        /*
     * @internal
     */ errors: ValidationError<VALUE>[];
        /*
     * @internal
     */ id: string;
    };
    Blocks: {
        default?: [ValidationError<VALUE>[]];
    };
}
export default class Errors<VALUE> extends Component<ErrorsSignature<VALUE>> {
    static{
        template(`
    <div id={{@id}} aria-live="assertive" class={{styles.errors}} ...attributes>
      {{! <span><Icon @icon='dismiss-circle' @style='filled' /></span> }}
      {{#if (has-block)}}
        {{yield @errors}}
      {{else}}
        <div>
          {{#each @errors as |e|}}
            {{#if e.message}}
              <p
                data-test-error
                data-test-error-type="{{e.type}}"
                data-test-error-value="{{e.value}}"
              >{{e.message}}</p>
            {{/if}}
          {{/each}}
        </div>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy8tcHJpdmF0ZS9mb3JtL2NvbXBvbmVudHMvZXJyb3JzLmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5cbmltcG9ydCBzdHlsZXMgZnJvbSAnQGhva3VsZWEvY29yZS9mb3Jtcy5tb2R1bGUuY3NzJztcblxuLy8gaW1wb3J0IEljb24gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9pY29uJztcbmltcG9ydCB0eXBlIHsgVmFsaWRhdGlvbkVycm9yIH0gZnJvbSAnLi4vJztcblxuZXhwb3J0IGludGVyZmFjZSBFcnJvcnNTaWduYXR1cmU8VkFMVUU-IHtcbiAgRWxlbWVudDogSFRNTERpdkVsZW1lbnQ7XG4gIEFyZ3M6IHtcbiAgICAvLyB0aGUgZm9sbG93aW5nIGFyZSBwcml2YXRlIGFyZ3VtZW50cyBjdXJyaWVkIGJ5IHRoZSBjb21wb25lbnQgaGVscGVyLCBzbyB1c2VycyB3aWxsIG5ldmVyIGhhdmUgdG8gdXNlIHRob3NlXG5cbiAgICAvKlxuICAgICAqIEBpbnRlcm5hbFxuICAgICAqL1xuICAgIGVycm9yczogVmFsaWRhdGlvbkVycm9yPFZBTFVFPltdO1xuXG4gICAgLypcbiAgICAgKiBAaW50ZXJuYWxcbiAgICAgKi9cbiAgICBpZDogc3RyaW5nO1xuICB9O1xuICBCbG9ja3M6IHtcbiAgICBkZWZhdWx0PzogW1ZhbGlkYXRpb25FcnJvcjxWQUxVRT5bXV07XG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEVycm9yczxWQUxVRT4gZXh0ZW5kcyBDb21wb25lbnQ8RXJyb3JzU2lnbmF0dXJlPFZBTFVFPj4ge1xuICA8dGVtcGxhdGU-XG4gICAgPGRpdiBpZD17e0BpZH19IGFyaWEtbGl2ZT1cImFzc2VydGl2ZVwiIGNsYXNzPXt7c3R5bGVzLmVycm9yc319IC4uLmF0dHJpYnV0ZXM-XG4gICAgICB7eyEgPHNwYW4-PEljb24gQGljb249J2Rpc21pc3MtY2lyY2xlJyBAc3R5bGU9J2ZpbGxlZCcgLz48L3NwYW4-IH19XG4gICAgICB7eyNpZiAoaGFzLWJsb2NrKX19XG4gICAgICAgIHt7eWllbGQgQGVycm9yc319XG4gICAgICB7e2Vsc2V9fVxuICAgICAgICA8ZGl2PlxuICAgICAgICAgIHt7I2VhY2ggQGVycm9ycyBhcyB8ZXx9fVxuICAgICAgICAgICAge3sjaWYgZS5tZXNzYWdlfX1cbiAgICAgICAgICAgICAgPHBcbiAgICAgICAgICAgICAgICBkYXRhLXRlc3QtZXJyb3JcbiAgICAgICAgICAgICAgICBkYXRhLXRlc3QtZXJyb3ItdHlwZT1cInt7ZS50eXBlfX1cIlxuICAgICAgICAgICAgICAgIGRhdGEtdGVzdC1lcnJvci12YWx1ZT1cInt7ZS52YWx1ZX19XCJcbiAgICAgICAgICAgICAgPnt7ZS5tZXNzYWdlfX08L3A-XG4gICAgICAgICAgICB7ey9pZn19XG4gICAgICAgICAge3svZWFjaH19XG4gICAgICAgIDwvZGl2PlxuICAgICAge3svaWZ9fVxuICAgIDwvZGl2PlxuICA8L3RlbXBsYXRlPlxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBRTNDLE9BQU8sWUFBWSxpQ0FBaUM7QUFFcEQsK0NBQStDO0FBQy9DLGNBQWMsZUFBZSxRQUFRLE1BQU07QUFFM0MsaUJBQWlCLGdCQUFnQjtJQUMvQixTQUFTO0lBQ1Q7UUFDRSw2R0FBNkc7UUFFN0c7O0tBRUMsR0FDRCxRQUFRLGdCQUFnQjtRQUV4Qjs7S0FFQyxHQUNELElBQUksTUFBTTs7SUFFWjtRQUNFLFdBQVcsZ0JBQWdCOzs7QUFJL0IsZUFBZSxNQUFNLE9BQU8sZUFBZSxVQUFVLGdCQUFnQjtJQUNuRSxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBbUJWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQW5CQTtBQW9CWiJ9